import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState: {
  isIframeLoaded: boolean;
  isLobbyFullscreen: boolean;
} = {
  isIframeLoaded: false,
  isLobbyFullscreen: false,
};

export const miniLobbySlice = createSlice({
  name: 'minilobby',
  initialState,
  reducers: {
    setIsIframeLoaded: (state, action: PayloadAction<boolean>) => {
      state.isIframeLoaded = action.payload;
    },
    setIsLobbyFullscreen: (state, action: PayloadAction<boolean>) => {
      state.isLobbyFullscreen = action.payload;
    },
  },
});

export const miniLobbyActions = miniLobbySlice.actions;
